import { useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import ComicCard from "@/components/feature/ComicCard";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

const slugCategoryMap: Record<string, string> = {
  rexue: "热血",
  gaoxiao: "搞笑",
  richang: "日常",
  zhiyu: "治愈",
  xuanyi: "悬疑",
};

export default function Category() {
  const { slug = "rexue" } = useParams();
  const cat = categories.find((c) => c.slug === slug) || categories[0];
  const catName = slugCategoryMap[slug] || cat.name;

  const filtered = useMemo(
    () => comics.filter((c) => c.category === catName),
    [catName],
  );

  const related = useMemo(
    () => comics.filter((c) => c.category !== catName).slice(0, 4),
    [catName],
  );

  return (
    <Layout>
      <title>{cat.name}漫画推荐 - 配快乐水一口气看完 | 可乐漫画</title>
      <meta name="description" content={`可乐漫画${cat.name}分类精选，${cat.tagline}。${cat.name}漫画推荐配快乐水，追更配零食，周末放松摸鱼必备。`} />
      <meta name="keywords" content={`可乐漫画,${cat.name}漫画,快乐水组合,追更配零食,肥宅快乐套餐`} />
      <link rel="canonical" href={`https://snackview.github.io/category/${slug}`} />

      {/* 分类头图 */}
      <section className="relative flex min-h-[280px] w-full items-end overflow-hidden md:min-h-[320px]">
        <img
          src={cat.cover}
          alt={`${cat.name} 分类头图`}
          title={`${cat.name} 快乐水追更`}
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/30 to-transparent" />
        <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-8 md:px-6">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm text-background-200">
            <Link to="/" className="hover:text-background-50">首页</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <Link to="/list" className="hover:text-background-50">追更榜单</Link>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-background-50">{cat.name}</span>
          </nav>
          <h1 className="mt-3 flex items-center gap-3 font-heading text-3xl text-background-50 md:text-4xl">
            <i className={cat.icon} style={{ width: 32, height: 32 }} />
            {cat.name}
          </h1>
          <p className="mt-2 text-sm text-background-100 md:text-base">{cat.tagline}</p>
        </div>
      </section>

      {/* 分类内容 */}
      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <h2 className="text-lg font-medium text-foreground-950 md:text-xl">
          本类精选 · {catName}
        </h2>
        <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.length > 0 ? (
            filtered.map((c) => <ComicCard key={c.id} comic={c} />)
          ) : (
            <p className="col-span-full rounded-lg border border-background-200 bg-background-100 p-6 text-sm text-foreground-600">
              该分类作品正在赶制中，先去其他分类看看你的快乐水组合吧。
            </p>
          )}
        </div>
      </section>

      {/* 更多推荐 */}
      <section className="border-t border-background-200 bg-background-100 py-10 md:py-14">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <h2 className="text-lg font-medium text-foreground-950 md:text-xl">更多快乐水追更推荐</h2>
          <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {related.map((c) => (
              <ComicCard key={c.id} comic={c} />
            ))}
          </div>
          <div className="mt-6">
            <Link
              to="/list"
              className="inline-flex items-center gap-1.5 rounded-full border border-primary-300 px-5 py-2.5 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50"
            >
              查看完整追更榜单
              <i className="ri-arrow-right-line" style={{ width: 16, height: 16 }} />
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}